<template>
  <v-container
    id="experience"
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <education />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <work />
      </v-col>
      <v-col
        cols="12"
      >
        <publications />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeExperience',

    components: {
      Education: () => import('@/components/Education'),
      Work: () => import('@/components/Work'),
      Publications: () => import('@/components/Publications'),
    },
  }
</script>
